import React from "react";

const PolygonIcon = () => (
  <svg
    width="42"
    height="17"
    viewBox="0 0 42 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M30 8.5L42 0L38 8.5L42 17L30 8.5Z" fill="white" />
    <path d="M28 8H0V9H28V8Z" fill="white" />
  </svg>
);

export default PolygonIcon;
